// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumPipelineCommand } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumPipelineCommand';
import { EnumPipelineHandleStatus } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumPipelineHandleStatus';
import { PipelinePublishPhase } from './PipelinePublishPhase';
import { PipelinePublishApp } from './PipelinePublishApp';
/**
 * 流水线发布任务 实体类
 * 记录IDE触发的一次流水线任务，通过命令或产品、应用设计期ID共同标识
 */
export class PipelinePublishTask extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 产品设计期ID : 产品设计期ID */
  private _productDesignId: string;

  /** 设置：产品设计期ID */
  public get productDesignId() {
    return this._productDesignId;
  }

  /** 获取：产品设计期ID */
  public set productDesignId(value: string) {
    this._productDesignId = value;
  }

  /** 是否需要编译 : 是否需要编译 */
  private _needCompile: boolean;

  /** 设置：是否需要编译 */
  public get needCompile() {
    return this._needCompile;
  }

  /** 获取：是否需要编译 */
  public set needCompile(value: boolean) {
    this._needCompile = value;
  }

  /** 流水线命令 : 流水线命令 */
  private _pipelineCommand: EnumPipelineCommand;

  /** 设置：流水线命令 */
  public get pipelineCommand() {
    return this._pipelineCommand;
  }

  /** 获取：流水线命令 */
  public set pipelineCommand(value: EnumPipelineCommand) {
    this._pipelineCommand = value;
  }

  /** 发布时间 : 发布时间，如果是未来时间，则进行预约发布 */
  private _publishOn: Date;

  /** 设置：发布时间 */
  public get publishOn() {
    return this._publishOn;
  }

  /** 获取：发布时间 */
  public set publishOn(value: Date) {
    this._publishOn = value;
  }

  /** 结束时间 : 结束时间，无论成功或失败 */
  private _finishOn: Date;

  /** 设置：结束时间 */
  public get finishOn() {
    return this._finishOn;
  }

  /** 获取：结束时间 */
  public set finishOn(value: Date) {
    this._finishOn = value;
  }

  /** 发布状态 : 发布状态 */
  private _publishStatus: EnumPipelineHandleStatus;

  /** 设置：发布状态 */
  public get publishStatus() {
    return this._publishStatus;
  }

  /** 获取：发布状态 */
  public set publishStatus(value: EnumPipelineHandleStatus) {
    this._publishStatus = value;
  }

  /** 应用设计期ID : 应用设计期ID */
  private _appDesignId: string;

  /** 设置：应用设计期ID */
  public get appDesignId() {
    return this._appDesignId;
  }

  /** 获取：应用设计期ID */
  public set appDesignId(value: string) {
    this._appDesignId = value;
  }

  /** 是否是测试环境 : 是否是测试环境 */
  private _isTest: boolean;

  /** 设置：是否是测试环境 */
  public get isTest() {
    return this._isTest;
  }

  /** 获取：是否是测试环境 */
  public set isTest(value: boolean) {
    this._isTest = value;
  }

  /** 发布阶段 */
  private _phases: Array<PipelinePublishPhase>;

  /** 获取：发布阶段 */
  public get phases() {
    return this._phases;
  }

  /** 设置：发布阶段 */
  public set phases(value: Array<PipelinePublishPhase>) {
    this._phases = value;
  }

  /** 发布应用 */
  private _publishApps: Array<PipelinePublishApp>;

  /** 获取：发布应用 */
  public get publishApps() {
    return this._publishApps;
  }

  /** 设置：发布应用 */
  public set publishApps(value: Array<PipelinePublishApp>) {
    this._publishApps = value;
  }

  constructor() {
    super();
    this._name = '';
    this._productDesignId = '';
    this._needCompile = false;
    this._pipelineCommand = EnumPipelineCommand.PublishProductFull;
    this._publishOn = new Date();
    this._finishOn = new Date();
    this._publishStatus = EnumPipelineHandleStatus.Padding;
    this._appDesignId = '';
    this._isTest = false;
    this._phases = new Array<PipelinePublishPhase>();
    this._publishApps = new Array<PipelinePublishApp>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PipelinePublishTask, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.productDesignId = element.productDesignId;
      this.needCompile = element.needCompile;
      this.pipelineCommand = element.pipelineCommand;
      this.publishOn = element.publishOn;
      this.finishOn = element.finishOn;
      this.publishStatus = element.publishStatus;
      this.appDesignId = element.appDesignId;
      this.isTest = element.isTest;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.productDesignId = json.ProductDesignId;
    this.needCompile = json.NeedCompile;
    this.pipelineCommand = json.PipelineCommand as EnumPipelineCommand;
    this.publishOn = new Date(json.PublishOn);
    this.finishOn = new Date(json.FinishOn);
    this.publishStatus = json.PublishStatus as EnumPipelineHandleStatus;
    this.appDesignId = json.AppDesignId;
    this.isTest = json.IsTest;
    if (json.Phases && json.Phases.length > 0) {
      json.Phases.forEach((element: any) => {
        const pipelinePublishPhase = PipelinePublishPhase.Create(element);
        // pipelinePublishPhase.task = this;
        this.phases.push(pipelinePublishPhase);
      });
    }
    if (json.PublishApps && json.PublishApps.length > 0) {
      json.PublishApps.forEach((element: any) => {
        const pipelinePublishApp = PipelinePublishApp.Create(element);
        // pipelinePublishApp.task = this;
        this.publishApps.push(pipelinePublishApp);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.ProductDesignId = this.productDesignId;
    json.NeedCompile = this.needCompile;
    json.PipelineCommand = this.pipelineCommand;
    json.PublishOn = this.publishOn;
    json.FinishOn = this.finishOn;
    json.PublishStatus = this.publishStatus;
    json.AppDesignId = this.appDesignId;
    json.IsTest = this.isTest;
    if (this.phases && this.phases.length > 0) {
      json.Phases = [];
      this.phases.forEach((element) => {
        json.Phases.push(element.toJson());
      });
    }
    if (this.publishApps && this.publishApps.length > 0) {
      json.PublishApps = [];
      this.publishApps.forEach((element) => {
        json.PublishApps.push(element.toJson());
      });
    }
  }

  static Create(json: any): PipelinePublishTask {
    const pipelinePublishTask = new PipelinePublishTask();
    pipelinePublishTask.Deserialize(json);
    pipelinePublishTask.json = json;
    return pipelinePublishTask;
  }
}
